import { get, isEmpty } from 'lodash';

import { environment } from '@environments/environment';

/**
 * App Mode Info
 * isDev: boolean - whether the app is running in dev mode (localhost & not production)
 * devToken?: string - dev token from environment variable (if any)
 */
export const appModeInfo = (
  hostname = window.location.hostname,
): {
  isDev: boolean;
  devToken?: string;
} => {
  const localhost = hostname === 'localhost';
  const production = get(environment, 'production', true);
  const isDev = !production && localhost;

  const devToken = isDev ? get(environment, 'DEV_TOKEN', '') : null;

  return {
    isDev,
    devToken: isEmpty(devToken) || devToken === 'undefined' ? null : devToken,
  };
};
